module.exports = __webpack_public_path__ + "static/media/3DPPA5.bec13a82.jpg";